// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2j4L0","col":"styles_col__CMt-u"};